/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 13:11:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/PageSetting/index.tsx
 */

import React from 'react';

//import css from './css.less';

import { Input } from '@/src/components/Antd';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { useDispatch } from 'react-redux';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getPageSetting,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onPageSettingChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import {
  TimeAndDatePickerWithAlwaysOn,
  formatDateFromServer,
} from 'src/constrains/TimeAndDatePickField';
import {
  ALWAYS_ON,
  deconstructionDate,
} from 'src/constrains/TimeAndDatePickField/TimeAndDatePickerWithAlwaysOn';
import { useI18n } from 'src/hooks/useRouterChange';
import { validatePageSetting } from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/tools';
import { i18nGet } from 'src/tools/tools';
const PageSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, display, specificError, hideTimeSelect } = props;

  const { nameError = [], timePickerError = [] } = specificError || {};
  const _d = useDispatch();

  const {
    name,
    alwaysOn,
    beginDate,
    beginTime,
    endDate,
    endTime,
    timezoneInGmt,
    status,
  } = data || {};

  const disableTimeSetting = status === 'InUse';
  const _startTime = formatDateFromServer(beginDate, beginTime);
  const _endTime = formatDateFromServer(endDate, endTime);

  const handleOnNameChange = (name) => {
    _d(onPageSettingChange({ name }));
  };

  const handleOnTypeChange = ({ type }) => {
    if (type === ALWAYS_ON) {
      _d(
        onPageSettingChange({
          alwaysOn: true,
          beginDate: null,
          beginTime: null,
          endDate: null,
          endTime: null,
        }),
      );
    } else {
      _d(
        onPageSettingChange({
          alwaysOn: false,
        }),
      );
    }
  };

  const handleOnTimeChange = ({ startTime: _startTime, endTime: _endTime }) => {
    const { beginDate, beginTime, endDate, endTime } = deconstructionDate(
      _startTime,
      _endTime,
    );

    _d(
      onPageSettingChange({
        beginDate,
        beginTime,
        endDate,
        endTime,
      }),
    );
  };

  return (
    <React.Fragment>
      <Section bottomBorder={!hideTimeSelect}>
        <ItemWrapper title={getI18n('general.pageName')}>
          <Input
            error={display && (nameError || []).length > 0}
            help={(nameError || []).join(' ')}
            maxLength={100}
            size='large'
            value={name}
            onChange={handleOnNameChange}
          />
        </ItemWrapper>
      </Section>
      {!hideTimeSelect && (
        <Section>
          <TimeAndDatePickerWithAlwaysOn
            disableStartTime={disableTimeSetting}
            data={{
              startTime: _startTime,
              endTime: _endTime,
              alwaysOn: alwaysOn,
            }}
            onTypeChange={handleOnTypeChange}
            onDateChange={handleOnTimeChange}
            error={
              display && (timePickerError || []).length > 0
                ? (timePickerError || []).join(' ')
                : false
            }
            timezone={timezoneInGmt}
          />
        </Section>
      )}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(PageSetting, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.pageSetting,
  getContent: getPageSetting,
  title: getI18nFromGeneral('general.hOCTitle.pageSetting'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validatePageSetting(x, !isPrimary);
  },
  getSubmitStamp,
});
